

const footerLinks = [
  { href: "/terms-of-use", label: "Terms of Use" },
  { href: "/privacy-policy", label: "Privacy Policy" },
  { href: "/legal-notice", label: "Legal Notice" },
  { href: "/cancellation-policy", label: "Cancellation Policy" },
  { href: "/cookies-policy", label: "Cookies Policy" },
];

export default function FooterLinks() {
  return (
    <div className="footer__links">
      {footerLinks.map(({ href, label }) => (
        <a key={href} href={href} target="_blank" rel="noopener noreferrer">
          {label}
        </a>
      ))}
      <p>
        We do our best to ensure that all information presented by us is complete, accurate and up to date.
        Nevertheless, We strongly advise you to check the regulation of destination country with authorities or your
        airline before you travel. It is travelers responsibility to check regulations and we cannot guarantee the
        reliability of the information on our website, including information about the coronavirus and the available
        tests. All information provided by us about the coronavirus, the different types of tests and related topics
        is based solely on reporting from official bodies.
      </p>
    </div>
  );
}


